import { render, staticRenderFns } from "./announcements-new-media-file.vue?vue&type=template&id=7c59e760&scoped=true&"
import script from "./announcements-new-media-file.vue?vue&type=script&lang=js&"
export * from "./announcements-new-media-file.vue?vue&type=script&lang=js&"
import style0 from "./announcements-new-media-file.vue?vue&type=style&index=0&id=7c59e760&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c59e760",
  null
  
)

export default component.exports